import {EVideoStatus, IVideo} from '../../../modules/rest';
import {formatViews, thumb} from '../../../modules/utils';
import stub from '../../../assets/images/icons/video_stub.svg';
import trash_svg from '../../../assets/images/icons/trash.svg';
import youtube_outline_svg from '../../../assets/images/icons/youtube_outline.svg';
import more_svg from '../../../assets/images/icons/more.svg';

import React, {FC, useCallback, useState} from 'react';
import {confirmDialog} from '../../../modules/confirm';
import {API} from '../../../modules/api';
import {toast} from 'react-toastify';
import {useTranslation} from "react-i18next";
import {Checkbox} from "../../../components/FormControls";
import Loadable from "../../../components/Loadable";
import {VideoStatuses} from "../../../modules/directory";
import ModalDropdown from "../../ModalDropdown";
import {ReactSVG} from "react-svg";
import {openVideoItemMoreModal} from "./VideoItemMoreModal";

interface Props {
  onChanged: () => void;
  video: IVideo;
  selectedVideosIds: number[];
  onSelectVideo: (id: number) => void;
}

const TrackVideoItem: FC<Props> = ({video, onChanged, selectedVideosIds, onSelectVideo}) => {
  const {t} = useTranslation();
  const [loading, setLoading] = useState(false);

  const cutoutTrack = useCallback(() => {
    confirmDialog(t('CUT_TRACK_CONFIRM_TITLE', {title: video.title}), {
      title: t('CUTTING_TRACK') || '',
      danger: true,
      confirmText: t('TRACK_CUT') || '',
    }).then((confirmed) => {
      if (!confirmed) return;
      setLoading(true);
      API.VideoEmbeds.cutYoutubeVideo(video.id)
        .then(() => {
          toast.success(t('TRACK_CUT_SUCCESS'));
          onChanged();
        })
        .catch(toast.error)
        .finally(() => setLoading(false));
    });
  }, [setLoading, video, onChanged, t]);

  const deleteVideo = useCallback(() => {
    confirmDialog(t('DELETE_CLIP_CONFIRM_TITLE', {title: video.title}), {
      title: t('DELETING_CLIP') || '',
      danger: true,
      confirmText: t('REMOVE') || '',
    }).then((confirmed) => {
      if (!confirmed) return;
      setLoading(true);
      API.VideoEmbeds.deleteYoutubeVideo(video.id)
        .then(() => {
          toast.success(t('CLIP_REMOVED'));
          onChanged();
        })
        .catch(toast.error)
        .finally(() => setLoading(false));
    });
  }, [setLoading, video, onChanged]);




  const handleMoreClick = () => {
    openVideoItemMoreModal(video).then((success) => {
      if (success) onChanged()
    })
  }

  const checked = selectedVideosIds.includes(video.id);

  return (
    <Loadable
      loading={loading}
      className={`my__tracks__modal__video__list__item${checked ? ' active' : ''}${checked || selectedVideosIds?.length ? ' checked' : ''}${!video.hasTrack || video.status !== EVideoStatus.Public ? ' disabled' : ''}`}>
      <div className='my__tracks__modal__video__list__item-id text-muted-14 text-medium'>
        #{video.id}
      </div>
      <div className='my__tracks__modal__video__list__item-checkbox text-muted-14'>
        <Checkbox checked={checked} onChange={() => onSelectVideo(video.id)}/>
      </div>
      <a href={`https://www.youtube.com/watch?v=${video.extId}`} target='_blank' className='my__tracks__modal__video__list__item-title d-flex align-items-center flex-grow-1 cursor-pointer' >
        <div className="my__tracks__modal__video__list__item-preview">
          <img
            alt="video"
            className=""
            src={video.cover ? thumb(video.cover!.id, 180) : stub}
          />
        </div>
        <div className="text-medium-14 text-truncate-2">
          {video.title || video.extId}
        </div>
      </a>
      <div className='text-muted-14 text-medium my__tracks__modal__video__list__item-status'>
        {t(video.hasTrack ? VideoStatuses[video.status] : 'TRACK_CUT')}
      </div>
      <div className='d-flex justify-content-between align-items-center my__tracks__modal__video__list__item-views'>
        {video.status === EVideoStatus.Public ? <span className="me-2 text-muted-14">{formatViews(video.views)}</span> :
          <span></span>}
        <ModalDropdown>
          <a  href={`https://studio.youtube.com/video/${video.extId}/edit`} target='_blank' className={`modal-dropdown-hidden-item`}>
            <ReactSVG src={youtube_outline_svg} className='react-icon'/>
            <span className="text-nowrap ps-2 text-muted">{t('GO_TO_STUDIO')}</span>
          </a>
          {/*{video.hasTrack &&*/}
          {/*  <div onClick={cutoutTrack} className={`modal-dropdown-hidden-item`}>*/}
          {/*    <ReactSVG src={cut_svg} className='react-icon'/>*/}
          {/*    <span className="text-nowrap text-muted ps-2">{t('TRACK_CUT')}</span>*/}
          {/*  </div>*/}
          {/*}*/}
          {/*<div onClick={deleteVideo} className={'modal-dropdown-hidden-item text-danger'}>*/}
          {/*  <ReactSVG src={trash_svg} className='react-icon'/>*/}
          {/*  <span className="text-nowrap ps-2">{t('REMOVE')}</span>*/}
          {/*</div>*/}
        </ModalDropdown>
        <ReactSVG src={more_svg} className='react-icon my__tracks__modal__video__list__item-more'
                  onClick={handleMoreClick}/>
      </div>
    </Loadable>
  );
};

export default TrackVideoItem;
